// shopping types
export default {
  GET_RECENTLY_ADDED_PRODUCTS: 'GET_RECENTLY_ADDED_PRODUCTS',
  GET_CATEGORY_PRODUCTS: 'GET_CATEGORY_PRODUCTS',

  GET_PRODUCT: 'GET_PRODUCT',
  GET_PRODUCT_BY_ID: 'GET_PRODUCT_BY_ID',
  GET_PRODUCT_ADD_BY: 'GET_PRODUCT_ADD_BY',
};
